import { last } from 'lodash';
import { DateTime } from 'luxon';

import { LoanInvestorRemittanceSplit } from '@willow/graphql-iso/src/app';
import { parseGqlIsoDate } from '@willow/types-iso';

export const getCurrentInvestorRemittanceSplit = (
  investorRemittanceSplits: LoanInvestorRemittanceSplit[],
  targetDate: Date = new Date(),
) => {
  const irSplit =
    last(
      investorRemittanceSplits.filter((split) => {
        const soldDateTime = split.soldDate
          ? DateTime.fromJSDate(parseGqlIsoDate(split.soldDate)).startOf('day')
          : undefined;
        const startDateTime = split.startDate
          ? DateTime.fromJSDate(parseGqlIsoDate(split.startDate)).startOf('day')
          : undefined;

        if (!soldDateTime && !startDateTime) {
          return false;
        }

        const targetDateTime = DateTime.fromJSDate(targetDate).startOf('day');
        const effectiveDate =
          soldDateTime && startDateTime
            ? soldDateTime < startDateTime
              ? soldDateTime
              : startDateTime
            : soldDateTime || startDateTime;

        return effectiveDate ? effectiveDate <= targetDateTime : false;
      }),
    ) ?? investorRemittanceSplits[0];

  return irSplit;
};
